import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@material-ui/core';
import { Error as ErrorIcon } from '@material-ui/icons';
import { useLocalizedMessage } from 'util/useLocalizedMessage';

// Simple valid syntax check using native DOM method
const isValidSelectorSyntax = (selector) => {
  if (!selector || !selector.trim()) return false;
  try {
    document.createDocumentFragment().querySelectorAll(selector);
    return true;
  } catch {
    return false;
  }
};

/**
 * Reusable single CSS selector input field with validation
 */
const SingleSelectorField = ({
  value,
  onChange,
  label,
  placeholder,
  helperText,
  required,
  ...props
}) => {
  const t = useLocalizedMessage();
  const [syntaxError, setSyntaxError] = useState(false);

  useEffect(() => {
    if (value && value.trim().length > 0) {
      const isValid = isValidSelectorSyntax(value);
      setSyntaxError(!isValid);
    } else {
      setSyntaxError(false);
    }
  }, [value]);

  const displayHelperText = syntaxError
    ? t('search.settings.selector.invalidDetailed')
    : helperText;

  return (
    <TextField
      {...props}
      fullWidth
      variant="outlined"
      label={label}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      helperText={displayHelperText}
      error={syntaxError}
      InputProps={{
        endAdornment: syntaxError ? (
          <InputAdornment position="end">
            <ErrorIcon style={{ color: '#f44336' }} />
          </InputAdornment>
        ) : null,
      }}
    />
  );
};

SingleSelectorField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  helperText: PropTypes.node,
  required: PropTypes.bool,
};

SingleSelectorField.defaultProps = {
  label: null,
  placeholder: null,
  helperText: null,
  required: false,
};

export default SingleSelectorField;
